import styles from "./styles.module.scss";

export const H3 = (props) => {
  const {children} = props;

  return <h3 className={styles.h3}>{children}</h3>;
};
